import BemIt from "@gtechdoodler/bem-it";
import { AppContainerProps } from "./AppContainer.types";
import { GlobalStyle } from "./AppContainer.styles";
import { ThemeProvider } from "styled-components";

const AppContainer: React.FC<AppContainerProps> = ({
	theme,
	children,
	...props
}) => {
	const block = new BemIt("AppContainer");

	return (
		<div className={block.out} {...props}>
			<ThemeProvider theme={theme}>
				<GlobalStyle />
				{children}
			</ThemeProvider>
		</div>
	);
};

export default AppContainer;
